import { useState } from "react";
import { format } from "date-fns";
import { cs } from "date-fns/locale";
import { CalendarDays, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Czech date picker: value/onChange work with ISO strings ("YYYY-MM-DD"), display is d. M. yyyy.
const DateInput = ({ value, onChange, placeholder = "Vyberte datum", className = "", testid, title }) => {
  const [open, setOpen] = useState(false);
  const date = value ? new Date(`${value}T00:00:00`) : undefined;
  const valid = date && !isNaN(date.getTime());

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" title={title} data-testid={testid}
          className={`input-dark flex items-center gap-2 text-left cursor-pointer ${className}`}>
          <CalendarDays className="w-3.5 h-3.5 text-zinc-500 shrink-0" />
          <span className={`truncate ${valid ? "" : "text-zinc-500"}`}>
            {valid ? format(date, "d. M. yyyy", { locale: cs }) : placeholder}
          </span>
          {valid && (
            <span
              role="button"
              onClick={(e) => { e.stopPropagation(); onChange(""); }}
              className="ml-auto text-zinc-500 hover:text-white shrink-0"
              title="Vymazat datum"
              data-testid={testid ? `${testid}-clear` : undefined}
            >
              <X className="w-3 h-3" />
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-[#141414] border border-white/10 text-zinc-100" align="start">
        <Calendar
          mode="single"
          locale={cs}
          weekStartsOn={1}
          selected={valid ? date : undefined}
          defaultMonth={valid ? date : undefined}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }}
        />
      </PopoverContent>
    </Popover>
  );
};

export default DateInput;
